import { MenuItem, TextField } from "@mui/material";
import { useGetProductCategoriesQuery } from "src/api/services/productCategoriesApi";
import { FilterProps } from "src/api/types";

const ProductCategoryFilter = ({
  filter,
  onChange,
  placeholder,
}: FilterProps) => {
  const { data } = useGetProductCategoriesQuery(undefined, {
    selectFromResult: (data) => {
      return { data: data?.data ?? [] };
    },
  });

  return (
    <TextField
      label={placeholder}
      select
      sx={{ width: 180 }}
      size="small"
      value={filter}
      onChange={onChange}
    >
      <MenuItem value={""}>{"None"}</MenuItem>
      {data.map((category) => (
        <MenuItem key={category.id} value={category.name}>
          {category.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default ProductCategoryFilter;
